import React from "react";
import { MdOutlineLocalActivity } from "react-icons/md";
import { LuChevronRight } from "react-icons/lu";
import { cn } from "../../../util/general";

const clampPercentage = (value) => Math.max(0, Math.min(1, value || 0));

const Coupon = ({
  couponName,
  printable,
  available,
  hexColor,
  multiplier,
  percentage,
  onClick,
}) => {
  const normalizedProgress = clampPercentage(percentage);
  const progress = Math.round(normalizedProgress * 100);
  const accentColor = hexColor || "#216EEE";
  const availableCount = available ?? "0";

  return (
    <div
      className="w-full rounded-[32px] bg-white p-5 border border-slate-200"
      onClick={onClick}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center min-w-0 gap-1">
            <div
              className="rounded-xl p-2.5 shrink-0"
              style={{
                backgroundColor: `${accentColor}14`,
                color: accentColor,
              }}
            >
              <MdOutlineLocalActivity size={20} />
            </div>
            <div className="min-w-0">
              <p className="text-base font-bold leading-tight truncate text-slate-950">
                {couponName ?? "--"}
              </p>
              <p className="text-xs text-slate-500">
                {printable ? "Cupon fisico" : "Cupon virtual"}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            {multiplier !== 1 && (
              <span
                className={cn(
                  "rounded-xl px-2.5 py-2 text-xs font-bold",
                  multiplier === 0 ? "bg-slate-100 text-slate-700" : "text-white"
                )}
                style={multiplier === 0 ? undefined : { backgroundColor: accentColor }}
              >
                {multiplier ? `x${multiplier}` : "x1"}
              </span>
            )}
          </div>
        </div>

        <div className="h-2 overflow-hidden rounded-full" style={{ backgroundColor: `${accentColor}14` }}>
          <div
            className="h-full rounded-full"
            style={{
              width: `${progress}%`,
              backgroundColor: accentColor,
            }}
          />
        </div>

        <div className="flex items-center justify-between gap-3">
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-extrabold tracking-tight text-[#0f1123]">
              {availableCount}
            </span>
            <span className="ml-1 text-sm text-[#7b7f9e]">
              {available === 1 ? "cupon acumulado" : "cupones acumulados"}
            </span>
          </div>
          <LuChevronRight size={20} />
        </div>
      </div>
    </div>
  );
};

export default Coupon;
